import { useState } from 'react';
import { BasicPage } from "../../theme/Component/BasicPage";
import { ProcedureIMP } from './ProcedureIMP';
import { AccountEditor } from '../../editor/AccountEditor';


export const AuditAccount = () => {

    const [tipoinput, setTipoinput] = useState(0);
    const [bean, setBean] = useState<any>({});
    const [code, setCode] = useState<any>('');

    const getListaCode = () => {

        if(code != '') 
        {
           setBean({ "AlphaCode": code });
        }
    }

    return (
        <>
            <BasicPage titulo="Auditoria de Solicitudes">
                <div className="row">
                    <div className="col-md-4">
                        <label>Buscar por</label>
                        <select name="tipo" className='form-select' value={tipoinput} onChange={(e) => setTipoinput(parseInt(e.target.value))}>
                            <option value="0">Solicitante</option>
                            <option value="1">Codigo Solicitud</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        {tipoinput === 0 &&
                            <>
                                <AccountEditor label='Solicitante' idAccount={bean.IDAccount} onChange={({ IDAccount }: any) => { setBean({ ...bean, "IDAccount": IDAccount }) }} />
                            </>
                        }
                        {tipoinput === 1 &&
                            
                                <div className="input-group" style={{ marginTop: '30px' }}>
                                    <input type="text" className="form-control" placeholder="" aria-label="Codigo de la solicitud" 
                                    aria-describedby="button-addon1" value={code} onChange={(e)=>{setCode(e.target.value)}}/>
                                    <button className="btn btn-outline-primary shadow-none" type="button" id="button-addon1" onClick={getListaCode}>Buscar</button>
                                </div>
                            
                        }
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12 mt-4">
                        <ProcedureIMP acc={bean} type={tipoinput}></ProcedureIMP>
                    </div>
                </div>
            </BasicPage>


        </>
    )
}